<script>
  import { urlServeur } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let rows;
  let promise;
  export let id;

  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api_formation/formationSal/" + id
    );

    if (response.ok) {
      const result = await response.json();
      rows = result.payload;
      //console.log(rows);
      return rows;
    } else {
      throw new (Error(text))();
    }
  };

  promise = fetchData();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <table class="table table-responsive table-success">
    <thead>
      <tr>
        <td>Date</td>
        <td>Durée</td>
        <td class="text-center">Libellé</td>
      </tr>
    </thead>
    <tbody>
      {#each elements as element}
        <tr>
          <td>{element.FO_DATE}</td>
          <td>{element.duree}</td>
          <td class="comment">{element.nom}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{:catch}
  Pas de formation
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .comment {
    font-size: 0.55em;
  }
</style>
